import { render, staticRenderFns } from "./SubmissionForm.vue?vue&type=template&id=b8535ac0"
import script from "./SubmissionForm.vue?vue&type=script&lang=ts"
export * from "./SubmissionForm.vue?vue&type=script&lang=ts"
import style0 from "./SubmissionForm.vue?vue&type=style&index=0&id=b8535ac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports